import { Icon } from '@abyss/web/ui/Icon';

export const OptumLogoIcon = () => (
  <Icon
    css={{
      width: '139px',
      height: '43px',
    }}
  >
    <svg
      id="Optum"
      viewBox="0 0 708 205.2"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      y="0px"
    >
      <defs></defs>
      <path
        d="M526.3,158.6V38.5h38.1l0.2,14.3c7.6-11,18.8-16.1,31.8-16.1c16.4,0,28,7.6,34.3,19.5c7.6-13,22-19.5,36.7-19.5
  c26.2,0,40.6,19.7,40.6,44.6v77.3h-38.8V87.2c0-11.7-7.4-18.6-16.4-18.6s-16.4,6.9-16.4,18.6v71.5h-38.8V87.2
  c0-11.7-7.4-18.6-16.4-18.6s-16.4,6.9-16.4,18.6v71.5L526.3,158.6L526.3,158.6z M513.3,112.9c0,30.9-24.6,48.4-56,48.4
  s-56-17.5-56-48.4V38.5h39v73.3c0,10.5,6.9,17.3,17,17.3s17-6.7,17-17.3V38.5h39V112.9z M390.7,69.5v-31h-32V7.8h-38.8v107.8
  c0,29.8,17.7,44.8,46.2,44.8c8.3,0,17-0.9,24.6-4v-30.7c-5.6,1.8-10.5,2.5-14.8,2.5c-10.3,0-17.3-4.7-17.3-15.7v-43L390.7,69.5
  L390.7,69.5z M270.9,98.6c0,17.3-12.5,30-28,30c-15.7,0-28.2-12.8-28.2-30c0-17,12.5-29.8,28.2-29.8
  C258.3,68.8,270.9,81.6,270.9,98.6z M214.6,205.2v-59.1c9.9,9.2,22.9,14.6,37.2,14.6c32.5,0,58-27.6,58-62.1
  c0-34.3-25.5-61.8-58-61.8c-15,0-28.2,5.8-38.3,15.7l-0.2-13.9h-37.6v166.7h38.9V205.2z M122.8,80.2c0,24.6-18.1,43-40.8,43
  s-40.8-18.4-40.8-43s18.1-43,40.8-43S122.8,55.6,122.8,80.2z M82,0C36.1,0,0,35.6,0,80.2s36.1,80.2,82,80.2s82-35.6,82-80.2
  S127.9,0,82,0z"
        fill="#FF612B"
      />
    </svg>
  </Icon>
);
